import {
    Box,
    Center,
    Stack,
    Flex,
    Text,
    Link,
    Heading,
    Wrap,
} from "@chakra-ui/layout";
import { Icon,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    useDisclosure,
    Slider,
    SliderTrack,
    SliderFilledTrack,
    SliderThumb,
} from "@chakra-ui/react"
import {
    VisuallyHidden,
    Switch,
    useColorModeValue as mode,
    Tooltip,
    IconButton,
    Button,
} from "@chakra-ui/react";
import { VscSettings } from "react-icons/vsc"
import  FocusLock from "react-focus-lock"
import * as React from "react";
import { textStyle } from "theme/names";

  
export const Filters = ({nbMinRt, setNbMinRt, nbMinLikes, setNbMinLikes, nbMaxDaysOld, setNbMaxDaysOld, nbMinDaysOld, setNbMinDaysOld}) => {
    const { onOpen, onClose, isOpen } = useDisclosure();
    const firstFieldRef = React.useRef(null);
  
    return (
        <Box width={100} display="flex" justifyContent="center" alignItems="center">
            <Popover
                isOpen={isOpen}
                initialFocusRef={firstFieldRef}
                onOpen={onOpen}
                onClose={onClose}
                placement="left"
                closeOnBlur={false}
                gutter={10}
            >
                <PopoverTrigger>
                <Button 
                    bg={mode("white", "#1E1E1E")} 
                    width={100} 
                    // rightIcon={<Icon w={5} h={5} as={VscSettings} />}
                    rightIcon={<Icon w={5} h={5} viewBox="0 0 16 15">
                    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12.5C0 12.0938 0.3125 11.75 0.75 11.75H2.59375C2.90625 10.75 3.875 10 5 10C6.09375 10 7.0625 10.75 7.375 11.75H15.25C15.6562 11.75 16 12.0938 16 12.5C16 12.9375 15.6562 13.25 15.25 13.25H7.375C7.0625 14.2812 6.09375 15 5 15C3.875 15 2.90625 14.2812 2.59375 13.25H0.75C0.3125 13.25 0 12.9375 0 12.5ZM6 12.5C6 11.9688 5.53125 11.5 5 11.5C4.4375 11.5 4 11.9688 4 12.5C4 13.0625 4.4375 13.5 5 13.5C5.53125 13.5 6 13.0625 6 12.5ZM11 5C12.0938 5 13.0625 5.75 13.375 6.75H15.25C15.6562 6.75 16 7.09375 16 7.5C16 7.9375 15.6562 8.25 15.25 8.25H13.375C13.0625 9.28125 12.0938 10 11 10C9.875 10 8.90625 9.28125 8.59375 8.25H0.75C0.3125 8.25 0 7.9375 0 7.5C0 7.09375 0.3125 6.75 0.75 6.75H8.59375C8.90625 5.75 9.875 5 11 5ZM12 7.5C12 6.96875 11.5312 6.5 11 6.5C10.4375 6.5 10 6.96875 10 7.5C10 8.0625 10.4375 8.5 11 8.5C11.5312 8.5 12 8.0625 12 7.5ZM15.25 1.75C15.6562 1.75 16 2.09375 16 2.5C16 2.9375 15.6562 3.25 15.25 3.25H8.375C8.0625 4.28125 7.09375 5 6 5C4.875 5 3.90625 4.28125 3.59375 3.25H0.75C0.3125 3.25 0 2.9375 0 2.5C0 2.09375 0.3125 1.75 0.75 1.75H3.59375C3.90625 0.75 4.875 0 6 0C7.09375 0 8.0625 0.75 8.375 1.75H15.25ZM5 2.5C5 3.0625 5.4375 3.5 6 3.5C6.53125 3.5 7 3.0625 7 2.5C7 1.96875 6.53125 1.5 6 1.5C5.4375 1.5 5 1.96875 5 2.5Z" fill="currentColor"/>
                    </svg>
                  </Icon>}
                >
                    Filters
                </Button>
                </PopoverTrigger>
                <PopoverContent boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;" width={400} p={5}>
                    <FocusLock returnFocus persistentFocus={false}>
                        <PopoverArrow />
                        <PopoverCloseButton />
                        <Stack spacing={4}>
                            <Text textStyle={textStyle["body.medium.light"]} fontSize="2xl" fontWeight="bold">Filters</Text>
                            <Box width="100%" display="flex" justifyContent="space-between">
                                <Text textStyle={textStyle["body.medium.light"]}>Min likes</Text>
                                <Text textStyle={textStyle["body.medium.light"]} as="i" fontWeight="100" >{nbMinLikes}</Text>
                                <Slider width={200} max={1000} aria-label="slider-min-likes" defaultValue={nbMinLikes} onChange={(val) => setNbMinLikes(val)}>
                                    <SliderTrack>
                                        <SliderFilledTrack />
                                    </SliderTrack>
                                    <SliderThumb />
                                </Slider>
                            </Box>
                            <Box width="100%" display="flex" justifyContent="space-between">
                                <Text textStyle={textStyle["body.medium.light"]}>Min RTs</Text>
                                <Text textStyle={textStyle["body.medium.light"]} as="i" fontWeight="100" >{nbMinRt}</Text>
                                <Slider width={200} max={1000} aria-label="slider-min-rt" defaultValue={nbMinRt} onChange={(val) => setNbMinRt(val)}>
                                    <SliderTrack>
                                        <SliderFilledTrack />
                                    </SliderTrack>
                                    <SliderThumb />
                                </Slider>
                            </Box>
                            <Box width="100%" display="flex" justifyContent="space-between">
                                <Text textStyle={textStyle["body.medium.light"]}>Min days old</Text>
                                <Text textStyle={textStyle["body.medium.light"]} as="i" fontWeight="100" >{nbMinDaysOld}</Text>
                                <Slider width={200} max={1000} aria-label="slider-oldest-days" defaultValue={nbMinDaysOld} onChange={(val) => setNbMinDaysOld(val)}>
                                    <SliderTrack>
                                        <SliderFilledTrack />
                                    </SliderTrack>
                                    <SliderThumb />
                                </Slider>
                            </Box>
                            <Box width="100%" display="flex" justifyContent="space-between">
                                <Text textStyle={textStyle["body.medium.light"]}>Max days old</Text>
                                <Text textStyle={textStyle["body.medium.light"]} as="i" fontWeight="100" >{nbMaxDaysOld}</Text>
                                <Slider width={200} max={1000} aria-label="slider-oldest-days" defaultValue={nbMaxDaysOld} onChange={(val) => setNbMaxDaysOld(val)}>
                                    <SliderTrack>
                                        <SliderFilledTrack />
                                    </SliderTrack>
                                    <SliderThumb />
                                </Slider>
                            </Box>
                        </Stack>
                    </FocusLock>
                </PopoverContent>
            </Popover>
        </Box>
    );
  };
  